module.exports = __webpack_public_path__ + "static/media/mercedes-10.016587e5.jpg";